import Vue from 'vue'
import Vuex from 'vuex'
import vuexI18n from 'vuex-i18n'
import * as actions from './actions'
import sellers from './modules/sellers'

Vue.use(Vuex)

const store = new Vuex.Store({
  actions,
  modules: {
    sellers: sellers,
    i18n: vuexI18n.store
  },
  strict: false,
  plugins: []
})

Vue.use(vuexI18n.plugin, store)
const translationsEn = { 'content_dummy': 'This is some default content' }
Vue.i18n.add('en', translationsEn)
Vue.i18n.set('en')

export default store



// WEBPACK FOOTER //
// ./src/store/index.js